
import { Mixins } from 'vue-mixin-decorator';
import BasePage from '@/pages/BasePage.vue';

export default class NotFoundPage extends Mixins<BasePage>(BasePage) {}
